import type React from "react";
import { forwardRef } from "react";
import { cn } from "@utils/utils";
import styles from "./Input.module.scss";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <div className={styles["input-wrapper"]}>
        <input
          ref={ref}
          className={cn(
            styles["input-wrapper__field"],
            error && styles["input-wrapper__field--error"],
            className
          )}
          {...props}
        />
        {error && (
          <p className={styles["input-wrapper__error-message"]}>{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
